<template lang="pug">
  div
    h2.pb-4 Scholarship Journey of {{ firstName }}
    v-timeline(
      dense
      align-top
    )
      v-timeline-item(
        fill-dot
        small
      )
        v-form(
          ref="form"
          v-model="valid"
        )
          v-col(cols="4").pl-2.py-0.pr-0
            v-text-field(
              label="Title"
              v-model="title"
              clearable
              outlined
              :rules="[v => !!v || 'Title is required']"
              :disabled="loading"
            ).pr-2
          v-textarea(
            label="Description"
            placeholder="Place details of the event here..."
            v-model="body"
            clearable
            outlined
            counter="168"
            no-resize
            :rules="[v => !!v || 'Description is required', v => v.length <= 168 || 'Description should only be 168 characters or less']"
            :disabled="loading"
          ).pl-2
          v-flex(shrink).pl-2
            v-btn(
              color="primary"
              @click.stop="addTimeline"
              :disabled="!valid"
              :loading="loading"
            ).plain.px-8 Add
      v-slide-y-reverse-transition(group)
        v-timeline-item(
          fill-dot
          small
          v-for="(timeline, i) in localTimeline"
          :key="i"
        )
          v-card.pa-4
            p.mb-0.primary--text.font-weight-black.font-20 {{ timeline.title }}
            p.secondary--text.font-weight-bold.font-14 {{ formatDate(timeline.date) }}
            p.font-20.secondary--text 
              pre(wrap) {{ timeline.body }}
</template>

<script>
import datefnsFormat from 'date-fns/format';
import _ from 'lodash';

export default {
  props: {
    timelines: {
      type: Array
    },
    beneficiary: {
      type: Object
    }
  },
  watch: {
    timelines () {
      this.localTimeline = this.timelines;
    }
  },
  data () {
    return {
      title: '',
      body: '',
      loading: false,
      valid: false,
      localTimeline: []
    };
  },
  computed: {
    firstName () {
      const beneficiary = this.beneficiary || {};
      const name = beneficiary.name || {};
      return name.firstName || '';
    }
  },
  methods: {
    async addTimeline () {
      try {
        this.loading = true;
        await this.$store.dispatch(
          'timeline/create',
          {
            beneficiary: this.beneficiary.id,
            title: this.title,
            body: this.body
          }
        );

        const timelines = await this.$store.dispatch(
          'timeline/get',
          {
            beneficiary: this.beneficiary.id
          }
        );

        this.localTimeline = _.sortBy(timelines, ['date']).reverse();

        this.$enqueueSnack('Timeline added');
      } catch (err) {
        this.$enqueueSnack(err);
      } finally {
        this.loading = false;
        this.title = '';
        this.body = '';
        this.$refs.form.resetValidation();
      }
    },
    formatDate (date) {
      return datefnsFormat(new Date(date), 'MMM d, yyyy');
    }
  }
};
</script>

<style scoped>
pre {
  font-family: Poppins !important;
}
</style>